// src/pages/HomePage.js
import React from 'react';

const AboutPage = () => {
  return <div>
   
    <p> this is a about page</p>
    <br></br>
    <p>HOLA GILBERTO 🚀🚀🚀🚀🚀🚀🚀</p>
    </div>;
};

export default AboutPage;
